An array of positions that the person held or is currently holding at the organization.
